<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <simple-header :label="$t('global.back')" @click="$router.push({ name: 'home' })" />

      <mq-layout :mq="['mobile', 'tablet']">
        <div class="theme-button-container">
          <vv-box v-for="quiz in quizzes" :key="quiz.id">
            <div class="step-item-container" @click="generateRandomQuizAndOpenIt(quiz.id)">
              <div class="step-title">{{ quiz.name }}</div>
            </div>
          </vv-box>
        </div>
      </mq-layout>

      <mq-layout mq="desktop">
        <div class="desktop-wrapper" v-for="quiz in quizzes" :key="quiz.id">
          <vv-desktop-tile
            :title="quiz.name"
            @click="generateRandomQuizAndOpenIt(quiz.id)"
            :image="quiz.tileImage"
          />
        </div>
      </mq-layout>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'

import { GENERATE_RANDOM_QUIZ } from '@/store/modules/quiz/types'
import userMixin from '@/mixins/user'
import VvScreenWrapper from '@/components/common/VvScreenWrapper'
import VvBox from '@/components/common/VvBox'
import SimpleHeader from '@/components/navigation/SimpleHeader'
import VvDesktopTile from '@/components/common/VvDesktopTile'

export default {
  name: 'QuizList',
  components: { VvDesktopTile, SimpleHeader, VvBox, VvScreenWrapper },
  mixins: [userMixin],
  computed: {
    ...mapGetters({
      quizzes: 'getQuizzes'
    })
  },
  methods: {
    generateRandomQuizAndOpenIt(quizId) {
      this.$store.dispatch(GENERATE_RANDOM_QUIZ, { contentType: 'quiz', contentId: quizId })

      this.$router.push({
        name: 'quiz',
        params: {
          contentType: 'quiz',
          contentId: quizId,
          quizId: quizId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.theme-button-container {
  padding: 0 10px;
  margin-top: 15px;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;

  .theme-button {
    width: 40%;

    &.first {
      margin-right: 10%;
    }
  }

  .step-item-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.desktop-wrapper {
  display: inline-block;
  width: 33%;
  padding-right: 20px;
  box-sizing: border-box;
  vertical-align: top;
  margin-bottom: 20px;
}
</style>
